// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "es6-promise/auto";

import Vue from "vue";
import store from "./store";
import i18n from "./lang/lang";
import BootstrapVue from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import Icon from "vue-awesome/components/Icon";
import "vue-awesome/icons";
import VueD3 from "vue-d3";
import Vue2Filters from "vue2-filters";
import VueMoment from "vue-moment";
import moment from "moment";
import router from "./router";
import FormInputNumeric from "./plugins/form-input-numeric";
// import DateRangePicker from './components/datePickerRange/index'
import MoonLoader from "vue-preload-spinner/src/MoonLoader";
import App from "./App";
import "@/assets/icons/icons";
import "./components/datePickerRange/assets/daterangepicker.css";
import VueCollapse from "vue2-collapse";
import MultiselectCustom from "./utils/multiselect/Multiselect";
import DateRangePicker from "@/components/datePickerRange/components/DateRangePicker";

Vue.config.productionTip = false;
Vue.use(BootstrapVue);
Vue.use(VueD3);
Vue.use(Vue2Filters);
Vue.use(VueMoment);
Vue.use(FormInputNumeric);

// Loading the plugin into the Vue.
Vue.use(VueCollapse);
Vue.use(MultiselectCustom);
Vue.component("Icon", Icon);
Vue.component("MoonLoader", MoonLoader);
Vue.component("DateRangePicker", DateRangePicker);

Date.prototype.isValid = function () {
  // An invalid date object returns NaN for getTime() and NaN is the only
  // object not strictly equal to itself.
  return this.getTime() === this.getTime();
};

Vue.filter("formatDate", function (value) {
  const date = moment(value, moment.ISO_8601, true);
  if (date.isValid()) {
    return date.toDate().toLocaleDateString();
  } else {
    return value;
  }
});

Vue.filter("formatDateWithTime", function (value) {
  const date = moment(value, moment.ISO_8601, true);
  if (date.isValid()) {
    return date.format("L LTS");
  } else {
    return value;
  }
});

/* eslint-disable no-new */
export const app = new Vue({
  store: store,
  i18n,
  el: "#app",
  router,
  components: {
    App,
  },
  template: "<App/>",
  render: (h) => h(App),
}).$mount("#app");

window["vue"] = app;
window.store = store;
